'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _dec, _dec2, _class, _class2, _temp; /**
                                          * Created by lyj on 2016/8/8.
                                          */

// import { load, isLoaded } from 'redux/modules/customProductDetail';


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Header = require('../Header/Header');

var _Header2 = _interopRequireDefault(_Header);

var _reactRedux = require('react-redux');

var _customProductDetail = require('redux/modules/customProductDetail');

var customProductDetailActions = _interopRequireWildcard(_customProductDetail);

var _preselection = require('redux/modules/preselection');

var _groupBuying = require('redux/modules/groupBuying');

var _attentionArtwork = require('redux/modules/attentionArtwork');

var _attentionShop = require('redux/modules/attentionShop');

var _attentionDesigner = require('redux/modules/attentionDesigner');

var _reduxAsyncConnect = require('redux-async-connect');

var _components = require('components');

var _reactRouterRedux = require('react-router-redux');

var _reactRouter = require('react-router');

var _background = require('redux/modules/background');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CustomProductDetail = (_dec = (0, _reduxAsyncConnect.asyncConnect)([{
  deferred: true,
  promise: function promise(_ref) {
    var _ref$store = _ref.store;
    var dispatch = _ref$store.dispatch;
    var getState = _ref$store.getState;
    var params = _ref.params;

    if (!customProductDetailActions.isLoaded(getState())) {
      var promises = [];
      promises.push(dispatch((0, _background.changeHeaderText)('定制艺品主页')));
      promises.push(dispatch(customProductDetailActions.load(params.productId)));
      /*
       .then(()=> {
       dispatch(customProductDetailActions.getCustomScheme(params.productId));
       }))*/
      return _promise2.default.all(promises);
    }
  }
}]), _dec2 = (0, _reactRedux.connect)(function (state) {
  return {
    data: state.customProductDetail.data,
    attentionData: state.attentionArtwork.addData,
    preselectionData: state.preselection.addData,
    attentionShopData: state.attentionShop.addData,
    attentionDesignerData: state.attentionDesigner.addData,
    newCustomData: state.customProductDetail.newCustomData,
    gettedCustomScheme: state.customProductDetail.gettedCustomScheme,
    buyImmediatelyData: state.preselection.buyData
  };
}, (0, _extends3.default)({}, customProductDetailActions, {
  addProductToPreselection: _preselection.addToPreselection,
  addToAttention: _attentionArtwork.add,
  clearAddInfo: _attentionArtwork.clearAdd,
  addToShopAttention: _attentionShop.add,
  clearShopAddInfo: _attentionShop.clearAdd,
  addToDesignerAttention: _attentionDesigner.add,
  clearDesignerAddInfo: _attentionDesigner.clearAdd,
  clearProductAddInfo: _preselection.productAddedInfoAllClear,
  clearImmediatelyBuyData: _preselection.clearBuyImmediatelyInfo,
  routerPush: _reactRouterRedux.push,
  groupBuying: _groupBuying.submitGroupBuying,
  buyProductImmediately: _preselection.buyImmediately
})), _dec(_class = _dec2(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(CustomProductDetail, _Component);

  function CustomProductDetail() {
    (0, _classCallCheck3.default)(this, CustomProductDetail);

    var _this = (0, _possibleConstructorReturn3.default)(this, (0, _getPrototypeOf2.default)(CustomProductDetail).call(this));

    _this.state = {
      number: 1,
      headerActiveIndex: 0,
      services: '',
      packaging: '',
      groupBuying: '',
      packagingModalOpenFrom: '',
      servicesModalOpenFrom: '',
      customModalOpenFrom: '',
      custom: {
        scheme: '',
        material: {},
        customs: {}
      },
      showOrHideBuyBlock: '',
      isPackagingOpened: false,
      isServicesModalOpened: false,
      isGroupBuyingModalOpened: false,
      isCustomItemModalOpened: false,
      isPrivilegeModalOpened: false,
      isTipModalOpened: false,
      disabledScrollListeners: false,
      isInStockModalOpened: false,
      attentionModelOpen: false
    };
    return _this;
  }

  (0, _createClass3.default)(CustomProductDetail, [{
    key: 'onCustomClick',
    value: function onCustomClick(from) {
      var _props = this.props;
      var getCustomScheme = _props.getCustomScheme;
      var params = _props.params;
      var gettedCustomScheme = _props.gettedCustomScheme;

      if (!gettedCustomScheme) {
        getCustomScheme(params.productId);
      }
      this.setState({
        isCustomItemModalOpened: true,
        isTipModalOpened: false,
        customModalOpenFrom: from || '',
        disabledScrollListeners: true
      });
    }
  }, {
    key: 'onCustomConfirm',
    value: function onCustomConfirm(data) {
      // console.log(JSON.stringify(data));
      this.setState({
        custom: data,
        isCustomItemModalOpened: false,
        disabledScrollListeners: true,
        isTipModalOpened: true
      });
    }
  }, {
    key: 'onCustomModalClose',
    value: function onCustomModalClose() {
      var customModalOpenFrom = this.state.customModalOpenFrom;

      var isTipModalOpened = false;
      if (customModalOpenFrom === 'tipModal') {
        isTipModalOpened = true;
      }
      this.setState({
        isCustomItemModalOpened: false,
        isTipModalOpened: isTipModalOpened,
        disabledScrollListeners: false
      });
    }
  }, {
    key: 'onPackagingClick',
    value: function onPackagingClick(from) {
      this.setState({
        isPackagingModalOpened: true,
        isTipModalOpened: false,
        packagingModalOpenFrom: from || '',
        disabledScrollListeners: true
      });
    }
  }, {
    key: 'onPackagingConfirm',
    value: function onPackagingConfirm(data) {
      this.setState({
        packaging: data.packaging,
        isPackagingModalOpened: false,
        isTipModalOpened: true,
        disabledScrollListeners: false
      });
    }
  }, {
    key: 'onServicesClick',
    value: function onServicesClick(from) {
      this.setState({
        isServicesModalOpened: true,
        isTipModalOpened: false,
        servicesModalOpenFrom: from || '',
        disabledScrollListeners: true
      });
    }
  }, {
    key: 'onServicesConfirm',
    value: function onServicesConfirm(data) {
      this.setState({
        services: data.services,
        isServicesModalOpened: false,
        isTipModalOpened: true,
        disabledScrollListeners: false
      });
    }
  }, {
    key: 'onPackagingModalClose',
    value: function onPackagingModalClose() {
      var packagingModalOpenFrom = this.state.packagingModalOpenFrom;

      var isTipModalOpened = false;
      if (packagingModalOpenFrom === 'tipModal') {
        isTipModalOpened = true;
      }
      this.setState({
        isPackagingModalOpened: false,
        isTipModalOpened: isTipModalOpened,
        disabledScrollListeners: false
      });
    }
  }, {
    key: 'onPrivilegeClick',
    value: function onPrivilegeClick() {
      this.setState({
        isPrivilegeModalOpened: true,
        disabledScrollListeners: true
      });
    }
  }, {
    key: 'onPrivilegeModalClose',
    value: function onPrivilegeModalClose() {
      this.setState({
        isPrivilegeModalOpened: false,
        disabledScrollListeners: false
      });
    }
  }, {
    key: 'onServicesModalClose',
    value: function onServicesModalClose() {
      var servicesModalOpenFrom = this.state.servicesModalOpenFrom;

      var isTipModalOpened = false;
      if (servicesModalOpenFrom === 'tipModal') {
        isTipModalOpened = true;
      }
      this.setState({
        isServicesModalOpened: false,
        isTipModalOpened: isTipModalOpened,
        disabledScrollListeners: false
      });
    }
  }, {
    key: 'onGroupBuyingItemClick',
    value: function onGroupBuyingItemClick(groupBuyingItemId) {
      var _props2 = this.props;
      var routerPush = _props2.routerPush;
      var params = _props2.params;
      var groupBuying = _props2.groupBuying;
      var _state = this.state;
      var services = _state.services;
      var packaging = _state.packaging;

      var packagingGroup = '';
      var currentPackaging = '';
      if (typeof packaging === 'string' && packaging.split(',').length === 2) {
        packagingGroup = packaging.split(',')[0];
        currentPackaging = packaging.split(',')[1];
      }
      if (groupBuying) {
        groupBuying({
          productId: params.productId,
          services: services,
          packagingGroup: packagingGroup,
          packaging: currentPackaging,
          groupBuyingPlan: groupBuyingItemId
        }).then(function (nextData) {
          if (nextData.isValid) {
            routerPush('/payment/' + nextData.payNumber + '/' + nextData.activeId);
          }
        });
      }
    }
  }, {
    key: 'onGroupBuyingModalClose',
    value: function onGroupBuyingModalClose() {
      this.setState({
        isGroupBuyingModalOpened: false,
        disabledScrollListeners: false
      });
    }
  }, {
    key: 'onCustomTipModalClose',
    value: function onCustomTipModalClose() {
      this.setState({
        disabledScrollListeners: false,
        isTipModalOpened: false
      });
    }
  }, {
    key: 'onCloseSuccessModal',
    value: function onCloseSuccessModal() {
      var clearAddInfo = this.props.clearAddInfo;
      var attentionModelOpen = this.state.attentionModelOpen;

      if (attentionModelOpen) {
        this.setState({
          attentionModelOpen: false
        });
      } else {
        if (clearAddInfo) {
          clearAddInfo();
        }
      }
    }
  }, {
    key: 'onCloseShopAttentionSuccessModal',
    value: function onCloseShopAttentionSuccessModal() {
      var clearShopAddInfo = this.props.clearShopAddInfo;

      if (clearShopAddInfo) {
        clearShopAddInfo();
      }
    }
  }, {
    key: 'onCloseDesignerAttentionSuccessModal',
    value: function onCloseDesignerAttentionSuccessModal() {
      var clearDesignerAddInfo = this.props.clearDesignerAddInfo;

      if (clearDesignerAddInfo) {
        clearDesignerAddInfo();
      }
    }
  }, {
    key: 'onCloseAddedToPreselectionSuccessModal',
    value: function onCloseAddedToPreselectionSuccessModal() {
      var clearProductAddInfo = this.props.clearProductAddInfo;

      if (clearProductAddInfo) {
        clearProductAddInfo();
      }
    }
  }, {
    key: 'onCloseBuyImmediatelyModal',
    value: function onCloseBuyImmediatelyModal() {
      var clearImmediatelyBuyData = this.props.clearImmediatelyBuyData;

      if (clearImmediatelyBuyData) {
        clearImmediatelyBuyData();
      }
    }
  }, {
    key: 'onBigCarouselModalClose',
    value: function onBigCarouselModalClose() {
      this.setState({
        isBigCarouselModalOpened: false,
        disabledScrollListeners: false
      });
    }
  }, {
    key: 'onBigCarouselModalOpen',
    value: function onBigCarouselModalOpen() {
      this.setState({
        isBigCarouselModalOpened: true,
        disabledScrollListeners: true
      });
    }
  }, {
    key: 'onBuyImmediately',
    value: function onBuyImmediately() {
      var _this2 = this;

      var _props3 = this.props;
      var buyProductImmediately = _props3.buyProductImmediately;
      var params = _props3.params;
      var routerPush = _props3.routerPush;
      var _state2 = this.state;
      var services = _state2.services;
      var packaging = _state2.packaging;
      var number = _state2.number;
      var custom = _state2.custom;

      var packagingGroup = '';
      var currentPackaging = '';
      if (typeof packaging === 'string' && packaging.split(',').length === 2) {
        packagingGroup = packaging.split(',')[0];
        currentPackaging = packaging.split(',')[1];
      }
      if (buyProductImmediately) {
        buyProductImmediately({
          productId: params.productId,
          number: number.toString(),
          services: services,
          packagingGroup: packagingGroup,
          packaging: currentPackaging,
          // 选择的定制参数
          scheme: custom.scheme,
          custom: (0, _extends3.default)({}, custom.material, custom.customs)
        }).then(function (resultData) {
          if (resultData && resultData.isValid) {
            _this2.setState({
              isTipModalOpened: false,
              custom: {
                scheme: '',
                material: {},
                customs: {}
              }
            });
            routerPush('/orderwriting/' + resultData.orderNumber);
          }
        });
      }
    }
  }, {
    key: 'onOpenInStockModal',
    value: function onOpenInStockModal() {
      this.setState({
        isInStockModalOpened: true
      });
    }
  }, {
    key: 'onCloseInStockModal',
    value: function onCloseInStockModal() {
      this.setState({
        isInStockModalOpened: false
      });
    }
  }, {
    key: 'activeChange',
    value: function activeChange(nextSection) {
      this.setState({
        headerActiveIndex: nextSection
      });
    }
  }, {
    key: 'addToShopcart',
    value: function addToShopcart() {
      var _this3 = this;

      var _props4 = this.props;
      var addProductToPreselection = _props4.addProductToPreselection;
      var params = _props4.params;
      var _state3 = this.state;
      var services = _state3.services;
      var packaging = _state3.packaging;
      var number = _state3.number;
      var custom = _state3.custom;

      var packagingGroup = '';
      var currentPackaging = '';
      if (typeof packaging === 'string' && packaging.split(',').length === 2) {
        packagingGroup = packaging.split(',')[0];
        currentPackaging = packaging.split(',')[1];
      }
      if (addProductToPreselection) {
        addProductToPreselection({
          productId: params.productId,
          number: number.toString(),
          services: services,
          packagingGroup: packagingGroup,
          packaging: currentPackaging,
          // 选择的定制参数
          scheme: custom.scheme,
          custom: (0, _extends3.default)({}, custom.material, custom.customs)
        }).then(function (resultData) {
          if (resultData && resultData.isValid) {
            _this3.setState({
              isTipModalOpened: false,
              custom: {
                scheme: '',
                material: {},
                customs: {}
              }
            });
          }
        });
      }
    }
  }, {
    key: 'addToAttention',
    value: function addToAttention(productId) {
      var _this4 = this;

      /*
       const {params, addToAttention} = this.props;
       let currentProductId = productId;
       if (!currentProductId) {
       currentProductId = params.productId;
       }
       if (addToAttention) {
       addToAttention(currentProductId);
       }
       */
      var _props5 = this.props;
      var params = _props5.params;
      var addToAttention = _props5.addToAttention;
      var getCustomProductAttentionStateData = _props5.getCustomProductAttentionStateData;
      var data = _props5.data;
      var customProductDetailAttentionState = data.customProductDetailAttentionState;

      var currentProductId = productId;
      if (!currentProductId) {
        currentProductId = params.productId;
      }
      if (addToAttention) {
        if (customProductDetailAttentionState instanceof Array && customProductDetailAttentionState[0].isAttention === '1') {
          this.setState({
            attentionModelOpen: true
          });
        } else if (customProductDetailAttentionState instanceof Array && customProductDetailAttentionState[0].isAttention === '0') {
          addToAttention(currentProductId).then(function (nextData) {
            // console.log(nextData);
            if (nextData.isValid) {
              getCustomProductAttentionStateData(currentProductId);
            }
          });
        } else {
          getCustomProductAttentionStateData(currentProductId).then(function (nextData) {
            // console.log(nextData);
            if (nextData.isValid && nextData.customProductDetailAttentionState instanceof Array) {
              _this4.addToAttention(currentProductId);
            }
          });
        }
      }
    }
  }, {
    key: 'addToShopAttention',
    value: function addToShopAttention(shopId) {
      var addToShopAttention = this.props.addToShopAttention;

      if (addToShopAttention && shopId) {
        addToShopAttention(shopId);
      }
    }
  }, {
    key: 'addToDesignerAttention',
    value: function addToDesignerAttention(designerId) {
      var addToDesignerAttention = this.props.addToDesignerAttention;

      if (addToDesignerAttention && designerId) {
        addToDesignerAttention(designerId);
      }
    }
  }, {
    key: 'isEmptyObject',
    value: function isEmptyObject(element) {
      var tvar = void 0;
      for (tvar in element) {
        if (tvar) {
          return !1;
        }
      }
      return !0;
    }
  }, {
    key: 'showOrHideBuyBlock',
    value: function showOrHideBuyBlock() {
      var showOrHideBuyBlock = this.state.showOrHideBuyBlock;

      if (showOrHideBuyBlock) {
        this.setState({
          showOrHideBuyBlock: false
        });
      } else {
        this.setState({
          showOrHideBuyBlock: true
        });
      }
    }
  }, {
    key: 'isContentToShow',
    value: function isContentToShow(item) {
      for (var _index = 0; _index < item.length; _index++) {
        if (item[_index].img) {
          return true;
        }
      }
      return false;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this5 = this;

      var _state4 = this.state;
      var
      // number,
      headerActiveIndex = _state4.headerActiveIndex;
      var isBigCarouselModalOpened = _state4.isBigCarouselModalOpened;
      var isServicesModalOpened = _state4.isServicesModalOpened;
      var isPackagingModalOpened = _state4.isPackagingModalOpened;
      var isGroupBuyingModalOpened = _state4.isGroupBuyingModalOpened;
      var isCustomItemModalOpened = _state4.isCustomItemModalOpened;
      var isPrivilegeModalOpened = _state4.isPrivilegeModalOpened;
      var isTipModalOpened = _state4.isTipModalOpened;
      var services = _state4.services;
      var packaging = _state4.packaging;
      var custom = _state4.custom;
      var packagingModalOpenFrom = _state4.packagingModalOpenFrom;
      var servicesModalOpenFrom = _state4.servicesModalOpenFrom;
      var disabledScrollListeners = _state4.disabledScrollListeners;
      var showOrHideBuyBlock = _state4.showOrHideBuyBlock;
      var isInStockModalOpened = _state4.isInStockModalOpened;
      var attentionModelOpen = _state4.attentionModelOpen;
      var data = this.props.data;

      var allPrice = 0;
      var resultDiv = _react2.default.createElement('div', null);
      if (data) {
        (function () {
          var productDetailFirstPage = data.productDetailFirstPage;
          var productDetailParams = data.productDetailParams;
          var productDetailDesigner = data.productDetailDesigner;
          var productDetailShop = data.productDetailShop;
          var productDetailPrivilege = data.productDetailPrivilege;
          var
          // productDetailPrivilegeBackground,
          productDetailPackaging = data.productDetailPackaging;
          var productDetailServices = data.productDetailServices;
          var groupBuying = data.groupBuying;
          var productDetailBasicInfo = data.productDetailBasicInfo;
          var productDetailBigCarousel = data.productDetailBigCarousel;
          var _props6 = _this5.props;
          var attentionData = _props6.attentionData;
          var attentionShopData = _props6.attentionShopData;
          var attentionDesignerData = _props6.attentionDesignerData;
          var preselectionData = _props6.preselectionData;
          var params = _props6.params;
          var newCustomData = _props6.newCustomData;
          var buyImmediatelyData = _props6.buyImmediatelyData;
          var getCustomMaterial = _props6.getCustomMaterial;
          var getCustomItems = _props6.getCustomItems;

          if (newCustomData) {
            var customScheme = newCustomData.customScheme;
            var customMaterial = newCustomData.customMaterial;
            var customItems = newCustomData.customItems;

            if (customScheme instanceof Array) {
              var chosenScheme = customScheme.find(function (currentInfo) {
                return currentInfo.id === custom.scheme;
              });
              if (chosenScheme && !isNaN(parseFloat(chosenScheme.price))) {
                allPrice += parseFloat(chosenScheme.price);
              }
            }
            if (customMaterial instanceof Array) {
              customMaterial.forEach(function (currentInfo) {
                var chosenMaterial = custom.material;
                if (chosenMaterial[currentInfo.groupId] === currentInfo.id) {
                  allPrice += parseFloat(currentInfo.price);
                }
              });
            }
            if (customItems instanceof Array) {
              customItems.forEach(function (currentInfo) {
                var chosenItems = custom.customs;
                if (chosenItems[currentInfo.groupId] === currentInfo.id) {
                  allPrice += parseFloat(currentInfo.price);
                }
              });
            }
          }
          if (productDetailPackaging instanceof Array && packaging) {
            var findInfo = productDetailPackaging.find(function (item) {
              return item.groupId === packaging.split(',')[0] && item.id === packaging.split(',')[1];
            });
            if (findInfo && !isNaN(parseFloat(findInfo.price))) {
              allPrice += parseFloat(findInfo.price);
            }
          }
          if (productDetailServices instanceof Array && services) {
            services.split(',').forEach(function (currentService) {
              var findInfo = productDetailServices.find(function (item) {
                return item.id === currentService;
              });
              if (findInfo && !isNaN(parseFloat(findInfo.price))) {
                allPrice += parseFloat(findInfo.price);
              }
            });
          }

          var isAttentionModalOpened = false;
          var attentionErrorMsg = '';
          if (attentionData) {
            attentionErrorMsg = attentionData.message;
            isAttentionModalOpened = !!attentionErrorMsg;
          }

          if (attentionModelOpen) {
            attentionErrorMsg = '艺品已关注';
            isAttentionModalOpened = attentionModelOpen;
          }

          var isShopAttentionModalOpened = false;
          var shopAttentionErrorMsg = '';
          if (attentionShopData) {
            shopAttentionErrorMsg = attentionShopData.message;
            isShopAttentionModalOpened = !!shopAttentionErrorMsg;
          }

          var isDesignerAttentionModalOpened = false;
          var designerAttentionErrorMsg = '';
          if (attentionDesignerData) {
            designerAttentionErrorMsg = attentionDesignerData.message;
            isDesignerAttentionModalOpened = !!designerAttentionErrorMsg;
          }

          var isAddedToPreselectionModalOpened = false;
          var adddToPreselectionErrorMsg = '';
          if (preselectionData) {
            if (preselectionData.isValid) {
              adddToPreselectionErrorMsg = '添加成功';
            } else {
              adddToPreselectionErrorMsg = preselectionData.message;
            }
            isAddedToPreselectionModalOpened = adddToPreselectionErrorMsg && adddToPreselectionErrorMsg !== '';
          }

          var isBuyImmediatelyModalOpened = false;
          var buyImmediatelyErrorMsg = '';
          if (buyImmediatelyData) {
            buyImmediatelyErrorMsg = buyImmediatelyData.message;
            isBuyImmediatelyModalOpened = !!buyImmediatelyErrorMsg;
          }

          var productId = '';
          var productImg = '';
          var inStock = 0;
          if (productDetailBasicInfo instanceof Array && productDetailBasicInfo.length > 0) {
            productId = productDetailBasicInfo[0].productId;
            productImg = productDetailBasicInfo[0].img;
            if (!isNaN(parseInt(productDetailBasicInfo[0].inStock, 10))) {
              inStock = parseInt(productDetailBasicInfo[0].inStock, 10);
            }
          }

          var styles = require('../ProductDetails/ProductDetails.scss');
          var buyClassName = styles.acrt + ' ' + styles.tanstion;
          var priceClassName = styles.yx_ea + ' ' + styles.tanstion;
          if (showOrHideBuyBlock === true) {
            buyClassName = styles.acrt + ' ' + styles.tanstion + ' ' + styles.tranBuyF;
            priceClassName = styles.yx_ea + ' ' + styles.tanstion + ' ' + styles.tranf;
          } else if (showOrHideBuyBlock === false) {
            buyClassName = styles.acrt + ' ' + styles.tanstion;
            priceClassName = styles.yx_ea + ' ' + styles.tanstion;
          }
          var anchors = ['productDetailFirstPage'];
          var array = [{
            text: '首页',
            href: 'productDetailFirstPage',
            type: 'nav',
            icon: 'icon01'
          }];
          var isShowQi = productDetailBasicInfo[0].minPrice === productDetailBasicInfo[0].maxPrice ? '' : ' 起';
          var contentDiv = [_react2.default.createElement(
            _components.FullPageSection,
            { key: '0', className: styles.goeasySection },
            _react2.default.createElement(
              'div',
              { className: styles.header },
              _react2.default.createElement(_Header2.default, null)
            ),
            productDetailFirstPage instanceof Array && _this5.isContentToShow(productDetailFirstPage) ? _react2.default.createElement(
              'div',
              { className: styles.firstFullPageItem },
              _react2.default.createElement(_components.ProductInfoFirstCarousel, { first: true,
                images: productDetailFirstPage })
            ) : _react2.default.createElement(
              'div',
              { className: styles.firstFullPageItem, style: { paddingTop: 100, fontSize: 20, textAlign: 'center' } },
              '艺品资料维护中......'
            ),
            _react2.default.createElement(
              'div',
              { className: styles.xuanfu },
              _react2.default.createElement(
                'article',
                { className: buyClassName },
                _react2.default.createElement(
                  'ul',
                  { className: styles.zbutn },
                  inStock > 0 ? _react2.default.createElement(
                    'li',
                    null,
                    _react2.default.createElement(
                      'span',
                      { onClick: _this5.addToShopcart.bind(_this5) },
                      _react2.default.createElement('img', {
                        src: 'http://tupian.goeasy.cn:9999/yipinwang/third/zbutn5.png', alt: '' })
                    )
                  ) : _react2.default.createElement(
                    'li',
                    null,
                    _react2.default.createElement(
                      'span',
                      { onClick: _this5.onOpenInStockModal.bind(_this5) },
                      _react2.default.createElement('img', {
                        src: 'http://tupian.goeasy.cn:9999/yipinwang/third/zbutn5.png', alt: '' })
                    )
                  ),
                  _react2.default.createElement(
                    'li',
                    null,
                    _react2.default.createElement(
                      _reactRouter.Link,
                      { to: '/personalcenter/personalbuying/productpreselection' },
                      _react2.default.createElement('img', {
                        src: 'http://tupian.goeasy.cn:9999/yipinwang/third/zbutn4.png', alt: '' })
                    )
                  ),
                  inStock > 0 ? _react2.default.createElement(
                    'li',
                    null,
                    _react2.default.createElement(
                      'span',
                      { onClick: _this5.onBuyImmediately.bind(_this5) },
                      _react2.default.createElement('img', {
                        src: 'http://tupian.goeasy.cn:9999/yipinwang/third/zbutn3.png', alt: '' })
                    )
                  ) : _react2.default.createElement(
                    'li',
                    null,
                    _react2.default.createElement(
                      'span',
                      { onClick: _this5.onCloseInStockModal.bind(_this5) },
                      _react2.default.createElement('img', {
                        src: 'http://tupian.goeasy.cn:9999/yipinwang/third/zbutn3.png', alt: '' })
                    )
                  ),
                  _react2.default.createElement(
                    'li',
                    null,
                    _react2.default.createElement(
                      'span',
                      { onClick: function onClick() {
                          return _this5.addToAttention(productId);
                        } },
                      _react2.default.createElement('img', {
                        src: 'http://tupian.goeasy.cn:9999/yipinwang/third/zbutn1.png', alt: '' })
                    )
                  ),
                  _react2.default.createElement(
                    'li',
                    null,
                    _react2.default.createElement(
                      'span',
                      { onClick: function onClick() {
                          return _this5.onCustomClick();
                        } },
                      _react2.default.createElement('img', {
                        src: 'http://tupian.goeasy.cn:9999/yipinwang/third/zbutn6.png', alt: '' })
                    )
                  )
                )
              ),
              _react2.default.createElement(
                'span',
                { onClick: _this5.showOrHideBuyBlock.bind(_this5), className: priceClassName },
                _react2.default.createElement(
                  'p',
                  {
                    className: styles.txt },
                  '¥ ' + (allPrice === 0 ? productDetailBasicInfo[0].minPrice + isShowQi : allPrice)
                )
              )
            )
          )];

          if (productDetailParams instanceof Array && productDetailParams.length > 0) {
            if (_this5.isContentToShow(productDetailParams)) {
              anchors.push('productDetailParams');
              array.push({
                text: '参数',
                href: 'productDetailParams',
                type: 'nav',
                icon: 'icon02'
              });
              contentDiv.push(_react2.default.createElement(
                _components.FullPageSection,
                { key: '1', className: styles.goeasySection },
                productDetailParams instanceof Array ? _react2.default.createElement(_components.ProductInfoFirstCarousel, { images: productDetailParams }) : ''
              ));
            }
          }

          if (productDetailBigCarousel instanceof Array && productDetailBigCarousel.length > 0) {
            array.push({
              text: '鉴赏',
              type: 'pop',
              icon: 'icon21',
              onClick: _this5.onBigCarouselModalOpen.bind(_this5)
            });
          }

          array.push({
            text: '定制',
            type: 'pop',
            className: 'back8',
            icon: 'icon04',
            onClick: _this5.onCustomClick.bind(_this5)
          });

          if (productDetailServices) {
            array.push({
              text: '服务',
              type: 'pop',
              icon: 'icon09',
              onClick: _this5.onServicesClick.bind(_this5)
            });
          }

          if (productDetailPackaging) {
            array.push({
              text: '包装',
              type: 'pop',
              icon: 'icon10',
              onClick: _this5.onPackagingClick.bind(_this5)
            });
          }

          if (productDetailPrivilege) {
            array.push({
              text: '优惠',
              type: 'pop',
              icon: 'icon07',
              onClick: _this5.onPrivilegeClick.bind(_this5)
            });
          }

          if (productDetailShop) {
            if (_this5.isContentToShow(productDetailShop)) {
              anchors.push('productDetailShop');
              array.push({
                text: '店铺',
                href: 'productDetailShop',
                type: 'nav',
                icon: 'icon06'
              });

              contentDiv.push(_react2.default.createElement(
                _components.FullPageSection,
                { key: '3', className: styles.goeasySection },
                productDetailShop instanceof Array ? _react2.default.createElement(_components.ProductInfoFirstCarousel, { images: productDetailShop }) : '',

                //  + '?fromProduct=' + params.productId + '&isCustom=1'
                productDetailShop instanceof Array && productDetailShop.length > 0 ? _react2.default.createElement(
                  'div',
                  { className: styles.visitDiv },
                  _react2.default.createElement(
                    _reactRouter.Link,
                    { to: '/shop/' + productDetailShop[0].shopId + '?isCustom=1',
                      className: styles.visitBtn,
                      target: '_blank' },
                    _react2.default.createElement('img', { src: 'http://tupian.goeasy.cn:9999/yipinwang/third/zbutn7.png' })
                  )
                ) : ''
              ));
            }
          }

          if (productDetailDesigner) {
            if (_this5.isContentToShow(productDetailDesigner)) {
              anchors.push('productDetailDesigner');
              array.push({
                text: '作者',
                href: 'productDetailDesigner',
                type: 'nav',
                icon: 'icon05'
              });

              contentDiv.push(_react2.default.createElement(
                _components.FullPageSection,
                { key: '2', className: styles.goeasySection },
                productDetailDesigner instanceof Array ? _react2.default.createElement(_components.ProductInfoFirstCarousel, { images: productDetailDesigner }) : '',

                //  + '?fromProduct=' + params.productId
                productDetailDesigner instanceof Array && productDetailDesigner.length > 0 ? _react2.default.createElement(
                  'div',
                  { className: styles.visitDiv },
                  _react2.default.createElement(
                    _reactRouter.Link,
                    {
                      to: '/designer/' + productDetailDesigner[0].designerId + '?isCustom=1',
                      className: styles.visitBtn,
                      target: '_blank' },
                    _react2.default.createElement('img', { src: 'http://tupian.goeasy.cn:9999/yipinwang/third/zbutn8.png' })
                  )
                ) : ''
              ));
            }
          }
          array.push({
            text: '百科',
            type: 'link',
            icon: 'icon22',
            url: 'http://baike.craftschina.cn/'
          });
          var options = {
            sectionClassName: 'section',
            anchors: anchors,
            scrollBar: false,
            activeClass: styles.active,
            navigation: false,
            verticalAlign: false,
            sectionPaddingTop: '0',
            sectionPaddingLeft: '0',
            sectionPaddingRight: '0',
            sectionPaddingBottom: '0'
          };
          resultDiv = _react2.default.createElement(
            'div',
            { className: styles.component },
            headerActiveIndex === 0 ? _react2.default.createElement(
              'a',
              { className: styles.nextIcon, href: '#productDetailParams' },
              _react2.default.createElement('img', {
                src: 'http://tupian.goeasy.cn:9999/yipinwang/xiala.png', alt: '' })
            ) : '',
            _react2.default.createElement(
              _components.FullPageHeader,
              null,
              _react2.default.createElement(_components.GoeasyFullPageHeader, { content: array, headerActiveIndex: headerActiveIndex })
            ),
            _react2.default.createElement(
              _components.FullPageSectionsContainer,
              (0, _extends3.default)({ activeChange: _this5.activeChange.bind(_this5),
                className: 'container' }, options, {
                disabledScrollListeners: disabledScrollListeners }),
              contentDiv
            ),
            _react2.default.createElement(_components.AttentionSuccessModal, { isOpened: isInStockModalOpened, closeModalFunc: _this5.onCloseInStockModal.bind(_this5),
              loginStyle: { background: 'url("http://tupian.goeasy.cn:9999/yipinwang/wbg/guanzhu_sucess_1.png") no-repeat' },
              text: '库存不足' }),
            productDetailPackaging ? _react2.default.createElement(_components.PackagingModal, { isOpened: isPackagingModalOpened, packagingData: productDetailPackaging,
              from: packagingModalOpenFrom,
              initialValues: { packaging: packaging },
              onSubmit: _this5.onPackagingConfirm.bind(_this5),
              onClose: _this5.onPackagingModalClose.bind(_this5) }) : '',
            productDetailServices ? _react2.default.createElement(_components.ServicesModal, { isOpened: isServicesModalOpened, servicesData: productDetailServices,
              from: servicesModalOpenFrom,
              initialValues: { services: services },
              onSubmit: _this5.onServicesConfirm.bind(_this5),
              onClose: _this5.onServicesModalClose.bind(_this5) }) : '',
            productDetailBigCarousel ? _react2.default.createElement(_components.DetailBigCarousel, { isOpened: isBigCarouselModalOpened, data: productDetailBigCarousel,
              onClose: _this5.onBigCarouselModalClose.bind(_this5) }) : '',
            productDetailPrivilege ? _react2.default.createElement(_components.PrivilegeModal, { isOpened: isPrivilegeModalOpened, privilegeData: productDetailPrivilege,
              onClose: _this5.onPrivilegeModalClose.bind(_this5) }) : '',
            groupBuying ? _react2.default.createElement(_components.GroupBuyingModal, { isOpened: isGroupBuyingModalOpened, onItemClick: _this5.onGroupBuyingItemClick.bind(_this5),
              onClose: _this5.onGroupBuyingModalClose.bind(_this5),
              data: groupBuying }) : '',
            _react2.default.createElement(_components.CustomItemModal, { isOpened: isCustomItemModalOpened,
              initialValues: { scheme: '', material: {}, customs: {} },
              onSubmit: _this5.onCustomConfirm.bind(_this5),
              onClose: _this5.onCustomModalClose.bind(_this5),
              getCustomMaterial: getCustomMaterial,
              getCustomItems: getCustomItems,
              params: params,
              productImg: productImg,
              newCustomData: newCustomData,
              isEmptyObject: _this5.isEmptyObject.bind(_this5) }),
            _react2.default.createElement(_components.CustomProductDetailTipModal, { isOpened: isTipModalOpened,
              allPrice: allPrice,
              customData: newCustomData,
              serviceData: productDetailServices,
              packagingData: productDetailPackaging,
              custom: custom,
              services: services, packaging: packaging,
              onCustomClick: _this5.onCustomClick.bind(_this5),
              onServiceClick: _this5.onServicesClick.bind(_this5),
              onPackagingClick: _this5.onPackagingClick.bind(_this5),
              onClose: _this5.onCustomTipModalClose.bind(_this5),
              onSubmit: _this5.addToShopcart.bind(_this5),
              onBuyAtonce: _this5.onBuyImmediately.bind(_this5) }),
            _react2.default.createElement(_components.AttentionSuccessModal, { isOpened: isAttentionModalOpened, closeModalFunc: _this5.onCloseSuccessModal.bind(_this5)
              // width="400"
              , loginStyle: { background: 'url("http://tupian.goeasy.cn:9999/yipinwang/wbg/guanzhu_sucess_1.png") no-repeat' },
              text: attentionErrorMsg }),
            _react2.default.createElement(_components.AttentionSuccessModal, { isOpened: isShopAttentionModalOpened
              // width="400"
              , loginStyle: { background: 'url("http://tupian.goeasy.cn:9999/yipinwang/wbg/guanzhu_sucess_1.png") no-repeat' },
              closeModalFunc: _this5.onCloseShopAttentionSuccessModal.bind(_this5),
              text: shopAttentionErrorMsg }),
            _react2.default.createElement(_components.AttentionSuccessModal, { isOpened: isDesignerAttentionModalOpened
              // width="400"
              , loginStyle: { background: 'url("http://tupian.goeasy.cn:9999/yipinwang/wbg/guanzhu_sucess_1.png") no-repeat' },
              closeModalFunc: _this5.onCloseDesignerAttentionSuccessModal.bind(_this5),
              text: designerAttentionErrorMsg }),
            _react2.default.createElement(_components.AttentionSuccessModal, { isOpened: isAddedToPreselectionModalOpened
              // width="400"
              , loginStyle: { background: 'url("http://tupian.goeasy.cn:9999/yipinwang/wbg/buy_sucess_1.png") no-repeat' },
              closeModalFunc: _this5.onCloseAddedToPreselectionSuccessModal.bind(_this5),
              text: adddToPreselectionErrorMsg }),
            _react2.default.createElement(_components.AttentionSuccessModal, { isOpened: isBuyImmediatelyModalOpened,
              loginStyle: { background: 'url("http://tupian.goeasy.cn:9999/yipinwang/wbg/buy_sucess_1.png") no-repeat' },
              closeModalFunc: _this5.onCloseBuyImmediatelyModal.bind(_this5),
              text: buyImmediatelyErrorMsg })
          );
        })();
      }
      return resultDiv;
    }
  }]);
  return CustomProductDetail;
}(_react.Component), _class2.propTypes = {
  data: _react.PropTypes.object.isRequired,
  location: _react.PropTypes.object,
  newCustomData: _react.PropTypes.object,
  attentionData: _react.PropTypes.object,
  attentionShopData: _react.PropTypes.object,
  attentionDesignerData: _react.PropTypes.object,
  preselectionData: _react.PropTypes.object,
  buyImmediatelyData: _react.PropTypes.object,
  packagingData: _react.PropTypes.object,
  dispatch: _react.PropTypes.func,
  addToAttention: _react.PropTypes.func,
  clearAddInfo: _react.PropTypes.func,
  addToShopAttention: _react.PropTypes.func,
  clearShopAddInfo: _react.PropTypes.func,
  addToDesignerAttention: _react.PropTypes.func,
  clearDesignerAddInfo: _react.PropTypes.func,
  clearProductAddInfo: _react.PropTypes.func,
  clearImmediatelyBuyData: _react.PropTypes.func,
  addProductToPreselection: _react.PropTypes.func,
  buyProductAtOnce: _react.PropTypes.func,
  routerPush: _react.PropTypes.func,
  groupBuying: _react.PropTypes.func,
  getCustomScheme: _react.PropTypes.func,
  getCustomMaterial: _react.PropTypes.func,
  getCustomItems: _react.PropTypes.func,
  clearBuyAtOnceErrorInfo: _react.PropTypes.func,
  isSchemeLoaded: _react.PropTypes.func,
  getState: _react.PropTypes.func,
  buyProductImmediately: _react.PropTypes.func,
  params: _react.PropTypes.object,
  gettedCustomScheme: _react.PropTypes.bool,
  getCustomProductAttentionStateData: _react.PropTypes.func
}, _temp)) || _class) || _class);
exports.default = CustomProductDetail;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/CustomProductDetail/CustomProductDetail.js
 ** module id = 1456
 ** module chunks = 0
 **/